import { useState, useEffect } from "react";
import { T } from "../../config/theme.js";
import { Btn } from "../ui/index.jsx";

export default function AlertSetter({ symbol, name, token }) {
  const [alerts, setAlerts] = useState([]);
  const [adding, setAdding] = useState(false);
  const [condition, setCondition] = useState("drop_5");

  const CONDITIONS = {
    drop_5: { label: "5% 이상 하락 시", desc: "전일 대비 5% 이상 떨어지면" },
    drop_10: { label: "10% 이상 하락 시", desc: "전일 대비 10% 이상 떨어지면" },
    vol_3x: { label: "거래량 3배 급증 시", desc: "평소보다 거래량이 3배 이상이면" },
    state_change: { label: "상태 변경 시", desc: "HOLD→CAUTION 등 상태가 바뀌면" },
    below_price: { label: "특정가 이하 도달 시", desc: "설정한 가격 아래로 내려가면" },
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(`phase_alerts_${symbol}`) || "[]");
    setAlerts(saved);
  }, [symbol]);

  const addAlert = () => {
    const newAlert = { id: Date.now(), condition, active: true, created: new Date().toISOString() };
    const updated = [...alerts, newAlert];
    setAlerts(updated);
    localStorage.setItem(`phase_alerts_${symbol}`, JSON.stringify(updated));
    setAdding(false);
  };

  const removeAlert = (id) => {
    const updated = alerts.filter(a => a.id !== id);
    setAlerts(updated);
    localStorage.setItem(`phase_alerts_${symbol}`, JSON.stringify(updated));
  };

  return (
    <div>
      {alerts.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          {alerts.map(a => (
            <div key={a.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: T.bg, borderRadius: 8, marginBottom: 4 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 14 }}>🔔</span>
                <span style={{ fontSize: 12, color: T.text, fontWeight: 600 }}>{CONDITIONS[a.condition]?.label || a.condition}</span>
              </div>
              <button onClick={() => removeAlert(a.id)} style={{ background: "none", border: "none", color: T.textMuted, cursor: "pointer", fontSize: 14 }}>✕</button>
            </div>
          ))}
        </div>
      )}
      {adding ? (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <select value={condition} onChange={e => setCondition(e.target.value)}
            style={{ padding: "8px 12px", background: T.bg, color: T.text, border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 12 }}>
            {Object.entries(CONDITIONS).map(([k, v]) => (
              <option key={k} value={k}>{v.label}</option>
            ))}
          </select>
          <Btn variant="small" onClick={addAlert}>추가</Btn>
          <Btn variant="ghost" style={{ fontSize: 11, padding: "6px 12px" }} onClick={() => setAdding(false)}>취소</Btn>
        </div>
      ) : (
        <Btn variant="ghost" style={{ fontSize: 12, width: "100%", justifyContent: "center" }} onClick={() => setAdding(true)}>
          + 알림 조건 추가
        </Btn>
      )}
      <div style={{ fontSize: 10, color: T.textMuted, marginTop: 6 }}>※ 알림은 리포트 생성 시 자동 체크됩니다</div>
    </div>
  );
}
